import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import LazyLoad from 'react-lazyload';
import Container from 'brastrap/common/container/Container';
import ProductPageSkeleton from '../../promotional/product-page/ProductPageSkeleton';
import { getConstructorRecommendations } from '../../../../shared/actions/constructor-recommendations';
import ConstructorRecommendationsRail from '../../promotional/constructorRecommendations/ConstructorRecommendationsRail';

const ConstructorRailContainer = ({
  linkedProductStyleCode,
  centreTitle,
  fullWidthRail,
  constructorPodId,
  numberOfResults,
  recommendations,
  title,
  isMobile,
  currency,
  recommendationsSlidesToShow,
  locale,
  fetchConstructorRecommendations,
}) => {
  const productStyleCode = linkedProductStyleCode?.toUpperCase() || null;

  useEffect(() => {
    fetchConstructorRecommendations(
      productStyleCode,
      constructorPodId,
      numberOfResults
    );
  }, []);

  const constructorRecommendationsData = {
    recommendedItems: recommendations.recommendations.recommendedItems,
    requestResultId: recommendations.recommendations.result_id,
    isFetching: recommendations.isFetching,
    failedRequest: recommendations.failedRequest,
    podId: constructorPodId,
    numberOfRequestedItems: numberOfResults,
    recommendedSeedItem: productStyleCode,
    slidesToShow: recommendationsSlidesToShow,
    centreTitle: centreTitle,
  };

  const constructorRecommendationsRail = (
    <ConstructorRecommendationsRail
      constructorProductRecommendations={constructorRecommendationsData}
      currency={currency}
      isMobile={isMobile}
      title={title}
      locale={locale}
    />
  );

  const hasRecommendations =
    !constructorRecommendationsData?.isFetching &&
    !constructorRecommendationsData?.failedRequest &&
    constructorRecommendationsData?.recommendedItems?.length > 0;
  return (
    <div>
      {constructorRecommendationsData.isFetching &&
        !constructorRecommendationsData.failedRequest && (
          <ProductPageSkeleton isMobile={isMobile} type={'recommendations'} />
        )}
      {hasRecommendations && (
        <LazyLoad>
          {!fullWidthRail ? (
            <Container>{constructorRecommendationsRail}</Container>
          ) : (
            <>{constructorRecommendationsRail}</>
          )}
        </LazyLoad>
      )}
    </div>
  );
};

const mapStateToProps = state => {
  return {
    currency: state.app.config.currency,
    isMobile: state.browser.deviceIs.mobile,
    locale: state.app.locale.selected,
    recommendationsEnabled: state.app.config.productRecommendations.enabled,
    recommendationsSlidesToShow:
      state.app.config.productRecommendations.slidesToShow,
    recommendations: state.getRecommendedProducts,
  };
};

const mapDispatchToProps = dispatch => ({
  fetchConstructorRecommendations: (
    productStyleCode,
    constructorPodId,
    numberOfResults
  ) =>
    dispatch(
      getConstructorRecommendations(
        productStyleCode,
        constructorPodId,
        numberOfResults
      )
    ),
});

ConstructorRailContainer.propTypes = {
  linkedProductStyleCode: PropTypes.string,
  numberOfResults: PropTypes.number,
  constructorPodId: PropTypes.string,
  recommendations: PropTypes.object,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  isMobile: PropTypes.bool,
  currency: PropTypes.string,
  recommendationsSlidesToShow: PropTypes.number,
  fullWidthRail: PropTypes.bool,
  centreTitle: PropTypes.bool,
  locale: PropTypes.string,
  fetchConstructorRecommendations: PropTypes.func,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConstructorRailContainer);
